export default __webpack_public_path__ + "static/media/jodhpur2.d0f5691b.jpg";